import React, { createContext, useReducer, useCallback } from 'react';
import { MenuListFlat } from '../constants/NavBar';

export const MenuContext = createContext();

const initialState = {
  menuListFlat: [],
  admins: [],
  loading: true
};

const menuReducer = (state, action) => {
  switch (action.type) {
    case 'SET_MENU_LIST':
      return {
        ...state,
        menuListFlat: action.payload,
        loading: false
      };
    case 'CLEAR_MENU_LIST':
      return {
        ...state,
        menuListFlat: [],
        loading: false
      };
    case 'SET_ADMINS':
      return {
        ...state,
        admins: action.payload,
        loading: false
      };
    case 'CLEAR_ADMINS':
      return {
        ...state,
        admins: [],
        loading: false
      };
    default:
      return state;
  }
};

const adminReducer = (state, action) => {
  switch (action.type) {
    case 'SET_ADMINS':
      return {
        ...state,
        admins: action.payload,
        loading: false
      };
    case 'CLEAR_ADMINS':
      return {
        ...state,
        admins: [],
        loading: false
      };
    default:
      return state;
  }
};

export const MenuProvider = ({ children }) => {
  const [state, dispatch] = useReducer(menuReducer, initialState);

  // Initialize menu list from constant
  const initializeMenuList = useCallback(() => {
    dispatch({
      type: 'SET_MENU_LIST',
      payload: MenuListFlat
    });
  }, []);

  // Set menu list manually
  const setMenuList = useCallback((menuList) => {
    dispatch({
      type: 'SET_MENU_LIST',
      payload: menuList
    });
  }, []);

  // Set menu list manually
  const setAdmins = useCallback((admins) => {
    dispatch({
      type: 'SET_ADMINS',
      payload: admins
    });
  }, []);

  // Get menu list
  const getMenuList = useCallback(() => {
    return state.menuListFlat;
  }, [state.menuListFlat]);

  // Get menu list
  const getAdmins = useCallback(() => {
    return state.admins;
  }, [state.admins]);

  const value = {
    ...state,
    initializeMenuList,
    setMenuList,
    getMenuList,
    setAdmins,
    getAdmins
  };

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export const useMenu = () => {
  const context = React.useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within MenuProvider');
  }
  return context;
};
